/**
 * components/layout/TimeModeToggle.tsx
 *
 * LOCAL | UTC segmented control in the Topbar. LOCAL shows station-bound
 * times in the station's zone, UTC in UTC (lib/utils/date.ts). Persisted
 * through the store's localStorage allowlist.
 */
import { useAppStore } from '@/lib/store';
import type { TimeMode } from '@/lib/utils/date';
import { cn } from '@/lib/utils/cn';

const MODES: { value: TimeMode; title: string }[] = [
  { value: 'LOCAL', title: "Station local time (each time in its own station's zone)" },
  { value: 'UTC', title: 'Coordinated Universal Time' },
];

export function TimeModeToggle(): React.JSX.Element {
  const timeMode = useAppStore((s) => s.timeMode);
  const setTimeMode = useAppStore((s) => s.setTimeMode);

  return (
    <div role="radiogroup" aria-label="Time display" className="flex items-center rounded-md border border-border p-0.5">
      {MODES.map((m) => (
        <button
          key={m.value}
          type="button"
          role="radio"
          aria-checked={timeMode === m.value}
          title={m.title}
          onClick={() => setTimeMode(m.value)}
          className={cn(
            'h-6 rounded-sm px-2.5 font-mono text-2xs uppercase tracking-wider transition-colors',
            timeMode === m.value
              ? 'bg-[#072D62] text-white'
              : 'text-muted-foreground hover:bg-muted',
          )}
        >
          {m.value}
        </button>
      ))}
    </div>
  );
}
